export default "__VITE_ASSET__CtivDtnL__"